export default __webpack_public_path__ + "static/media/download-files.f99a7cf6.jpg";